import React from "react";
import Slider from "react-slick";

import {
  VerticalSlider,
  CollectionSlide1,
  CollectionSlide2,
  CollectionSlide3,
} from "./collections-query-container";
import { MDBTypography, MDBBox, MDBRow, MDBCol, MDBContainer } from "mdbreact";

const CollectionsSection = () => {
  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    speed: 1500,
    cssEase: "ease-in",
    slidesToShow: 1,
    variableWidth: false,
    draggable: true,
    slidesToScroll: 1,
    lazyLoad: "ondemand",
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: false,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          swipe: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          infinite: false,
          autoplay: false,
          slidesToShow: 1.5,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          swipe: true,
        },
      },
    ],
  };

  return (
    <MDBContainer fluid className="collection-wrapper">
      <MDBRow fluid className="collection-wrapper-slider">
        <MDBCol className="collection-slider p-0" lg="9">
          <Slider {...sliderSettings}>
            <CollectionSlide1 />
            <CollectionSlide2 />
            <CollectionSlide3 />
          </Slider>
        </MDBCol>
        <MDBCol lg="3" className="vertical-slider">
          <MDBBox className="vertical-slider-heading">
            <MDBTypography
              className="explore-cards-title"
              tag="h2"
              variant="h6"
            >
              our collection
            </MDBTypography>
            <MDBTypography
              className="explore-cards-subtitle"
              tag="h3"
              variant="h6"
            >
              Basics
            </MDBTypography>
          </MDBBox>
          <VerticalSlider />
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default CollectionsSection;
